import axios from 'axios';

import { Environment } from '../../../environment';
import { responseInterceptor, errorInteceptor } from './interceptors';

export interface IPaginacao {
    totalCount: number,
    pageSize: number,
    currentPage: number,
    totalPages: number,
    hasNext: boolean,
    hasPrevious: boolean
}

const Api = axios.create({
    baseURL: Environment.URL_BASE,//URL base
    timeout: 180000, //Tempo limite de 3 minutos
});

//@ts-expect-error
Api.defaults.headers.common['Authorization'] = `Bearer ${JSON.parse(localStorage.getItem("ACESS_TOKEN"))}`

Api.interceptors.response.use(
    (response) => responseInterceptor(response),
    async (error) => {
        async function getMsg() {

            const blob = new Blob([error.response.data], { type: 'application/json' });

            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = async (event) => {
                    //@ts-expect-error
                    error.response.data = event.currentTarget.result.replaceAll('"', '')

                    resolve(error);
                };
                reader.onerror = (error) => {
                    reject(error);
                };
                reader.readAsText(blob);
            });

        }

        if (error.request.responseType == "blob") {
            await getMsg()
        }

        return errorInteceptor(error)
    },
);

export { Api };